<template>
  <div v-if="user.data.id">
    <div class="audit__filter filter">

      <div>
        <el-date-picker
          v-model="valueTimeRange"
          type="datetimerange"
          range-separator=""
          start-placeholder="From: 02.01.2024 01:30:00"
          end-placeholder="To: 08.12.2024 12:05:00"
          align="left"
          format="dd.MM.yyyy HH:mm:ss"
          @change="selectedTime"
          @blur="selectedTime"
        >
        </el-date-picker>
      </div>

      <div style="display: flex;">
        <el-select
          v-model="valueType"
          id="types"
          class="typeOptions"
          placeholder="Select"
          :fit-input-width="true"
          :default-first-option="true"
          @change="() => { pathOptions.queryType = valueType; fetchAuditData();}"
        >
          <el-option
            v-for="typeItem in typeList"
            :key="typeItem.value"
            :label="$t('audit.' + typeItem.label)"
            :value="typeItem.value"
            class="typeOptionsPopper"
          >
          </el-option>
        </el-select>
        <el-input
          id="search"
          class="filter__input"
          :placeholder="$t('audit.search_query')"
          v-model="searchTerm"
          clearable
          @change="search"
          @input="searchInput"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @change="search"
          ></el-button>
        </el-input>
      </div>

      <div style="white-space: nowrap; padding: 0">
        <switch-checkbox
          class="checkbox"
          style="margin: 0;"
          :text="$t('audit.exclude_guest_parking')"
          :onChange="toggleHideGuestParking"
          :checked="isHideGuestParking"
        />
      </div>

      <div v-show="!showFilters">
        <button
          type="submit"
          class="btn btn--main btnHoverOverwrite more-filters-button"
          style="display: flex; flex-direction: row; height: 40px; white-space: nowrap"

          v-on:click="this.toggleShowFilters"
        >
          <div style="white-space: nowrap">
            {{ $t('audit.more_filters') }}
          </div>
          <div
            style="padding: 4px 8px; justify-content: center; align-items: center; gap: 10px; border-radius: 999px; background: black; color: white; margin-left: 10px; font-size: 12px">
            {{ filtersAmount }}
          </div>
        </button>
      </div>
      <div v-show="showFilters">
        <button
          class="btn btn--secondary hide-filters-button"
          style="display: flex; flex-direction: row; cursor: pointer; height: 40px; padding: 10px 15px"
          v-on:click="this.toggleShowFilters"
        >
          <div style="white-space: nowrap">
            {{ $t('audit.hide_filters') }}
          </div>
          <div
            style="padding: 4px 8px; justify-content: center; align-items: center; gap: 10px; border-radius: 999px; background: black; color: white; margin-left: 10px; font-size: 12px">
            {{ filtersAmount }}
          </div>
        </button>
      </div>

      <div class="filter__perPage-container" style="width: 75px; display: none">
          <span v-show="(this.total / this.pathOptions.limit > 1 && valuePerPage === 15) || valuePerPage !== 15">
            <el-select
              v-model="valuePerPage"
              id="records"
              class="filter__perPage"
              placeholder="Select"
              @change="selectedPerPage"
            >
              <el-option
                v-for="perPage in optionsPerPage"
                :key="perPage.value"
                :label="perPage.label"
                :value="perPage.value">
              </el-option>
            </el-select>
          </span>
      </div>
    </div>
    <vue-good-table
      :columns="columns"
      :rows="rows"
      styleClass="vgt-table"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'created_at'"
              class="smaller-font">{{ props.row.created_at|formatDateWithWeekday }}</span>
        <span v-else-if="props.column.field == 'auditable_type'" class="smaller-font">
          <router-link
            v-if="props.row.auditable_type.subject_type.name !== ''"
            :to="props.row.auditable_type.subject_type" target="_blank" class="link"
          >
            {{ props.row.auditable_type.type }}
          </router-link>
          <span v-else>
            {{ props.row.auditable_type.type }}
          </span>
        </span>
        <div
          v-else-if="props.column.field == 'event'"
          :class="`record ${props.row.event}`"
        >
          <span>{{ $t('audit.event_' + props.row.event) }}</span>
        </div>
        <span v-else-if="props.column.field == 'account_email'">
          {{ props.row.account_name && props.row.account_name }} <br>
          {{ props.row.account_email && props.row.account_email }}
        </span>

        <div v-else-if="props.column.field === 'changes'">
          <div style="display: flex">
            <div v-if="props.row.changes.event !== 'deleted'" v-for="(value, label) in props.row.changes.changes.old" class="changedItems">
              <ChangedItemLabel v-if="props.row.changes.changes.attributes[label] !== value" :label="label"/>
            </div>
          </div>
          <div class="showMore" @click="openShowMoreDialog(props.row.changes)">
            {{ $t('audit.show_more') }}
          </div>
         </div>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>


    <div class="audit__pagination-container">
      <el-pagination
        v-show="this.total / this.pathOptions.limit > 1"
        background
        layout="prev, pager, next"
        :current-page="this.pathOptions.page"
        :page-size="this.pathOptions.limit"
        :total="this.total"
        @current-change="changePage">
      </el-pagination>
    </div>
    <div
      class="sideFilters__wrapper"
      :class="( showFilters ? 'showFilters' : 'hideFilters' )"
    >
      <AuditSideFilters @set-current-page="handleCurrentPageFromFilters"/>
    </div>



  </div>

</template>

<script>
import {mapGetters} from 'vuex';
import moment from 'moment';
import {diff} from 'deep-object-diff';
import {VueGoodTable} from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import SwitchCheckbox from 'common/SwitchCheckbox';
import AuditSideFilters from "./AuditSideFilters";
import ChangedItemLabel from "./ChangedItemLabel";


export default {
  name: 'MainView',
  components: {
    ChangedItemLabel,
    VueGoodTable,
    SwitchCheckbox,
    AuditSideFilters
  },
  computed: {
    ...mapGetters({
      user: 'user/user/user',
      audit: 'audit/audit/audit',
      showFilters: 'audit/audit/showFilters',
      eventTypeFilters: 'audit/audit/eventTypeFilters',
      modelTypeFilters: 'audit/audit/modelTypeFilters',
      isFetchDataNeeded: 'audit/audit/isFetchDataNeeded',
    }),
    filtersAmount() {
      return this.eventTypeFilters.length + this.modelTypeFilters.length;
    },
  },

  mounted() {
    this.fetchAuditData();
  },
  data() {
    return {
      searchTerm: '',
      typeList: [
        {
          value: 0,
          label: 'all',
        },
        {
          value: 'landlord',
          label: 'landlord',
        },
        {
          value: 'tenant',
          label: 'tenant',
        },
        {
          value: 'permit_id',
          label: 'permit_number',
        },
        {
          value: 'vehicle_reg',
          label: 'plate_number',
        },
        {
          value: 'user',
          label: 'user_name',
        },
        {
          value: 'email',
          label: 'user_email',
        },
      ],
      valueType: 0,
      optionsPerPage: [
        {
          value: 15,
          label: 15,
        },
        {
          value: 25,
          label: 25,
        },
        {
          value: 50,
          label: 50,
        },
        {
          value: 100,
          label: 100,
        },
      ],
      valuePerPage: 15,
      valueTimeRange: [],
      columns: [],
      rows: [],
      total: 0,
      isHideGuestParking: true, //isHideGuestParking
      pathOptions: {
        q: '',
        limit: 15,
        orderBy: '',
        ascending: 1,
        page: 1,
        byColumn: 0,
        dateFrom: '',
        dateTo: '',
        isHideGuestParking: 1,
        queryType: ''
      },
      auditId: null,
      activeTabName: 'changes',
    };
  },
  watch: {
    isFetchDataNeeded(newValue, oldValue) {
      if (newValue === true) {
        this.fetchAuditData();
        this.$store.dispatch('audit/audit/setIsFetchDataNeeded', false);
      }
    },
  },
  methods: {
    handleCurrentPageFromFilters(value) {
      this.pathOptions.page = value;
    },
    openShowMoreDialog(itemChanges) {
      this.$store.dispatch('audit/audit/setAuditDialogShow', true);
      this.$store.dispatch('audit/audit/setAuditDialogData', itemChanges);
    },
    fetchAuditData() {
      if (this.user.data && this.user.data.selectedRole.id) {
        this.$store.dispatch('audit/audit/fetch', {
          user: this.user,
          options: {
            q: this.pathOptions.q,
            limit: this.pathOptions.limit,
            orderBy: this.pathOptions.orderBy,
            ascending: this.pathOptions.ascending,
            page: this.pathOptions.page,
            byColumn: this.pathOptions.byColumn,
            dateFrom: this.pathOptions.dateFrom,
            dateTo: this.pathOptions.dateTo,
            isHideGuestParking: this.pathOptions.isHideGuestParking,
            queryType: this.pathOptions.queryType,
            eventType: this.eventTypeFilters,
            modelType: this.modelTypeFilters
          },
        }).then(() => {
          this.columns = [
            {
              label: this.$t('audit.updated_at'),
              field: 'created_at',
              type: 'date',
              dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
              dateOutputFormat: 'dd.MM.yyyy HH:mm, EEEEEE',
              sortable: false,
              width: '15%',
            },
            {
              label: this.$t('audit.type'),
              field: 'auditable_type',
              sortable: false,
              width: '15%',
            },
            {
              label: this.$t('audit.event'),
              field: 'event',
              sortable: false,
              width: '200px',
            },
            {
              label: this.$t('audit.causer'),
              field: 'account_email',
              sortable: false,
              width: '250px',
            },
            {
              label: this.$t('audit.changes'),
              field: 'changes',
              sortable: false,
            },
          ];
          this.rows = [];
          this.audit.data.map((item) => {
            this.rows.push({
              created_at: this.formatISOToCustom(item.created_at),
              auditable_type: this.defineAuditableType(item),
              event: item.event ? item.event : '-',
              account_email: item.causer ? item.causer.email : '',
              account_name: this.defineNameByType(item),
              changes: item,
            })
          })
          this.total = this.audit.meta.total;
        });
      }
    },
    defineAuditableType(item) {

      let type = item.subject_type.split('\\').pop();
      const subject_type = this.auditableRouterLink(item)

      if (type !== 'Partner') {
        return  {
          subject_type,
          type,
        }
      }

      if (!item.subject) {
        if (item.changes.old.children && item.changes.old.children.length > 0) {
          type = 'Tenant';
        } else {
          type = 'Landlord';
        }
      } else {
        if (item.subject.parent_partner_id) {
          type = 'Tenant';
        } else {
          type = 'Landlord';
        }
      }

      return  {
        subject_type,
        type,
      }
    },
    defineNameByType(item) {
      if (!item.causer_type) {
        return 'System';
      }
      if (item.causer_type === 'App\\Models\\Account') {
        return 'Account';
      // } else if (item.causer_type === 'App\\Models\\PartnerKiosk') {
      //   return item.causer.user.name;
      } else if (item.causer_type === 'App\\Models\\EasyParking') {
        return item.causer.name;
      } else {
        return '';
      }
    },
    formatISOToCustom(isoDateString) {
      const date = new Date(isoDateString);

      if (isNaN(date.getTime())) {
        return 'Invalid Date';
      }

      const year = date.getFullYear().toString();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    search() {
      this.pathOptions.q = this.searchTerm;
      this.fetchAuditData();
    },
    searchInput(value) {
      if (value.trim() === '') {
        this.search();
      }
    },
    selectedPerPage() {
      this.pathOptions.limit = this.valuePerPage;
      this.fetchAuditData();
    },
    selectedTime() {
      if (this.valueTimeRange && this.valueTimeRange.length > 0) {
        this.pathOptions.dateFrom = moment(this.valueTimeRange[0]).format('YYYY-MM-DD HH:mm:ss');
        this.pathOptions.dateTo = moment(this.valueTimeRange[1]).format('YYYY-MM-DD HH:mm:ss');
      } else {
        this.pathOptions.dateFrom = '';
        this.pathOptions.dateTo = '';
      }
      this.fetchAuditData();
    },
    changePage(value) {
      this.pathOptions.page = value;
      this.fetchAuditData();
    },
    auditableRouterLink(row) {
      let route = '';
      let id = row.auditable_id;

      switch (row.subject_type) {
        case 'App\\Models\\Account':
          route = '';
          break;
        case 'App\\Models\\Vehicle':
          route = 'user';
          id = row.subject ? row.subject.user_id : '';
          break;
        case 'App\\Models\\User':
          route = 'user';
          id = row.subject ? row.subject.id : '';
          break;
        case 'App\\Models\\PartnerProduct':
          if (row.subject) {
            route = 'tenant';
            id = row.subject.partner_id;
          }
          break;
        case 'App\\Models\\Partner':
          if (row.subject) {
            if (!row.subject.parent_partner_id) {
              route = 'landlord';
            } else {
              route = 'tenant';
            }
            id = row.subject.id;
          }
          break;
        case 'App\\Models\\Product': {
          route = 'product';
          id = row.subject ? row.subject.id : '';
          break;
        }
        case 'App\\Models\\Permit':
          route = 'permit';
          id = row.subject ? row.subject.id : '';
          break;
        case 'App\\Models\\Zone': {
          route = 'zone';
          id = row.subject ? row.subject.id : '';
          break;
        }
        case 'App\\Models\\Parking': {
          route = 'parking';
          id = row.subject ? row.subject.id : '';
          break;
        }

        default:
          route = '';
      }
      return {
        name: route,
        params: {
          id,
        },
      };
    },
    auditableChanges(oldValues, newValues) {
      const diffResult = diff(oldValues, newValues);
      return this.auditableParse(diffResult);
    },
    auditableParse(values) {
      return Object.keys(values)
        .map((key) => {
          let value = values[key];
          if (value instanceof Object && value.date) {
            value = moment(value.date).format('DD.MM.YYYY HH:mm, dd');
          }
          return `${key}: ${value}`;
        })
        .join('<br>');
    },
    auditableDetails(row) {
      if (this.auditId === row.id) {
        this.auditId = null;
      } else {
        this.auditId = row.id;
      }
    },
    toggleHideGuestParking(isChecked) {
      if (isChecked === true) {
        this.pathOptions.isHideGuestParking = 1;
      } else {
        this.pathOptions.isHideGuestParking = 0;
      }
      this.isHideGuestParking = isChecked;
      this.fetchAuditData();
    },
    toggleShowFilters() {
      this.$store.dispatch('audit/audit/setShowFilters', !this.showFilters);
    },
  },
  filters: {
    formatDateWithWeekday(momentDate) {
      return momentDate == null ? '' : moment(momentDate).format('DD.MM.YYYY HH:mm, dd');
    },
  },
};
</script>

<style lang="scss">
@import '~styles/app.scss';


.vgt-global-search {
  display: none;
}

.vgt-table {
  thead {
    th {
      background: transparent;
    }

    td {
      vertical-align: center !important;
    }
  }
}

table.vgt-table tbody td.vgt-left-align {
  vertical-align: center !important;

}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: var(--brand-orange);
}

.switch-checkbox__custom--checked::before {
  background-color: var(--brand-orange) !important
}

.switch-checkbox__custom--checked::after {
  background-color: var(--brand-orange) !important;
}
.btnHoverOverwrite:hover {
  background-color: var(--brand-orange) !important;
  opacity: 0.8;
}

</style>

<style scoped>

@import './MainView.scss';


.filter__input >>> .el-input__inner {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.typeOptions >>> .el-input__inner {
  width: 100px;
  border-radius: 4px 0 0 4px;
  border-color: black;
  background: black;
  color: white;
}

.typeOptions >>> .el-select__caret {
  color: white;
}

.checkbox >>> .switch-checkbox__label {
  font-size: 14px;
}

.el-select-dropdown >>> .el-scrollbar {
  background: black !important;
}

.el-range-editor >>> .el-range-input {
  width: 100%;
}

</style>

<style lang="scss" scoped>

.el-button--text {
  margin-right: 15px;
}

.el-select {
  //width: 300px;
}

.el-input {
  width: 300px;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}

.changeset {
  cursor: pointer;
  word-break: break-all;
  max-height: 55px;
  overflow: hidden;
  display: inline-block;

  &.expanded {
    max-height: initial;
    max-width: initial;
  }
}

.audit {
  &__filter {
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    gap: 24px;

    @media screen and (max-width: 1290px) {
      flex-direction: column;
    }

  }

  &__pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
}


.checkbox {
  align-self: center;
  margin-left: 20px;
  height: 20px;

  //@media screen and (max-width: 1700px) {
  //  margin: 20px 0 0 0;
  //}

  @media screen and (max-width: 1200px) {
    margin: 0 0 0 20px;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/audit/MainView.vue